import React, {PropTypes} from 'react';
import {withGoogleMap, GoogleMap, Polygon} from 'react-google-maps';
import {findDOMNode} from 'react-dom';
import keydown from 'react-keydown';
import _ from 'lodash';
import DrawingManager from "react-google-maps/lib/drawing/DrawingManager";
import {gettext} from '../i18n/service.js';
import {darkTheme} from '../constants/mapStyles.js';

const GettingStartedGoogleMap = withGoogleMap(props => (
  <GoogleMap
  ref={props.onMapMounted}
  defaultZoom={3}
  defaultCenter={JSON.parse(localStorage.getItem('mapCenter'))?JSON.parse(localStorage.getItem('mapCenter')):{ lat: 0, lng: 0 }}
  defaultZoom={JSON.parse(localStorage.getItem('mapZoom'))?JSON.parse(localStorage.getItem('mapZoom')):3}
  onBoundsChanged={()=>props.setDefaultCenterAndZoom()}
  onClick={(e) => props.onMapClick(e)}
  options={{
      styles: darkTheme,
      gestureHandling: 'greedy'
    }}>
    {props.isDraw
      ? drawManager(props)
      : ''}
    {props.polygon
      ? <Polygon path={props.polygon}/>
      : ''}
    <button type="button" onClick={props.onClickOutsideOfMap} className="btn btn-danger btn-circle">
      <i className="glyphicon glyphicon-remove"></i>
    </button>
    {props.setPolygon
      ? <button type="button" onClick={() => props.onClickOutsideOfMap()} className="btn btn-primary btn-clear-polygon">
          {gettext('SET')}
        </button>
      : ''}
  </GoogleMap>
));

const drawManager = (props) => (<DrawingManager defaultOptions={{
  drawingControl: true,
  drawingControlOptions: {
    position: google.maps.ControlPosition.TOP_CENTER,
    drawingModes: [google.maps.drawing.OverlayType.POLYGON]
  }
}}
onOverlayComplete={(e) => {
  let coordinates = [];
  _.map(e.overlay.latLngs.j[0].j, (latlng) => {
    let point = {
      lat: latlng.lat(),
      lng: latlng.lng()
    }
    coordinates.push(point);
  });
  props.setPolygon(coordinates);
}}/>);

export default class MapComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    _.bindAll(this, ['handleMapMounted', 'setDefaultCenterAndZoom']);
  }
  @keydown('esc')
  onEscKeyDown() {
    this.props.onClickOutsideOfMap();
  }
  handleMapMounted(map) {
    this._map = map;
  }
  setDefaultCenterAndZoom() {
    let location = this._map.getCenter();
    localStorage.setItem('mapCenter', JSON.stringify({lat:location.lat(),lng:location.lng()}));
    localStorage.setItem('mapZoom', this._map.getZoom());
  }
  render() {
    return (
      <div>
        <div style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "rgba(0,0,0,0.2)"
        }} onClick={this.props.onClickOutsideOfMap}/>

        <GettingStartedGoogleMap
          containerElement={
            <div
              className = "mapModalWindow"
              style = {{ position: "fixed", top: "50px", bottom: "50px", left: "50px", right: "50px", boxShadow: "0 0 21px 0 #616161", zIndex: 1000 }} >
            </div>
          }
          mapElement={
            <div
              style = {{ height: `100%` }}/>
          }
          onClickOutsideOfMap={this.props.onClickOutsideOfMap}
          defaultZoom={this.props.defaultZoom}
          defaultCenter={this.props.defaultCenter}
          onMapClick={this.props.onMapClick}
          isDraw={this.props.isDraw}
          polygon={this.props.polygon}
          removePolygon={this.props.removePolygon}
          setPolygon={this.props.setPolygon}
          setDefaultCenterAndZoom={this.setDefaultCenterAndZoom}
          onMapMounted={this.handleMapMounted}/>
      </div>
    );

  }
}

MapComponent.propTypes = {
  onMapClick: PropTypes.func,
  onClickOutsideOfMap: PropTypes.func,
  onOkay: PropTypes.func,
  onCancel: PropTypes.func,
  defaultZoom: PropTypes.number,
  defaultCenter: PropTypes.object,
  hideMapEdit: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/MapModalComponent.js